// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3edKx","buttons":"SendReceipts_buttons__2Tlqi","email":"SendReceipts_email__3SNmd","bookApptTitle":"SendReceipts_bookApptTitle__Nh6CR"};